// eslint-disable-next-line import/named
import MuiCard, { CardProps as MuiCardProps } from "@mui/material/Card";
import theme from "@/designSystem/theme";

interface CardProps extends MuiCardProps {
  componentName: string;
}
export const Card = ({ componentName, children, ...props }: CardProps) => {
  return (
    <MuiCard
      {...props}
      data-testid={`${componentName}-card`}
      variant="outlined"
      sx={{
        mt: 2,
        width: "90%",
        borderRadius: 2,
        px: 2,
        py: 1,
        border: `2px solid ${theme.palette.primary.main}`,
        boxShadow: 2,
        position: "relative",
        minHeight: 200,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        ...props.sx,
      }}
    >
      {children}
    </MuiCard>
  );
};
